import { ViewModel } from './_vm'

/**
 * DateUndecided // datePicker描写のjs
 *
 * @returns {undefined}
 */
export class DateUndecided extends ViewModel {
  constructor($element, controller) {
    super(DateUndecided.name(), $element, controller)

    this.$element.on('click', () => this.trigger('dateUndecided'))
  }

  static name() {
    return 'DateUndecided'
  }

  static className() {
    return '#NTA_date_undecided-check'
  }
}
